/* MEIKA HOME — interacciones propias. Vanilla, sin librerías. */
(function () {
  'use strict';

  if (window.__mhInit) return;
  window.__mhInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveal al hacer scroll (un solo observer compartido) --------------- */
  function initReveal() {
    var root = document.documentElement;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      // no animamos: dejamos todo visible (no añadimos la clase que oculta)
      return;
    }
    root.classList.add('mh-anim-ready');

    function revealInView() {
      var h = window.innerHeight || 800;
      document.querySelectorAll('.mh-reveal:not(.mh-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < h * 0.98) el.classList.add('mh-visible');
      });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var siblings = Array.prototype.filter.call(
          el.parentElement ? el.parentElement.children : [],
          function (c) { return c.classList && c.classList.contains('mh-reveal'); }
        );
        var idx = siblings.indexOf(el);
        el.style.setProperty('--mh-delay', (idx > 0 ? Math.min(idx, 6) * 0.08 : 0) + 's');
        el.classList.add('mh-visible');
        io.unobserve(el);
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });

    document.querySelectorAll('.mh-reveal').forEach(function (el) { io.observe(el); });

    // Failsafe: si el observer no dispara (scroll rápido, navegador raro),
    // revelamos lo que ya esté a la vista sin matar el efecto del resto.
    window.addEventListener('scroll', revealInView, { passive: true });
    window.addEventListener('load', revealInView);
    setTimeout(revealInView, 1200);
  }

  /* --- Galería de la página de producto ---------------------------------- */
  function initPdpGallery() {
    var gal = document.querySelector('[data-mh-gallery]');
    if (!gal) return;
    var stage = gal.querySelector('[data-mh-stage]');
    var thumbs = gal.querySelectorAll('[data-mh-thumb]');
    if (!stage || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (full) stage.innerHTML = '<img src="' + full + '" alt="' + alt.replace(/"/g, '&quot;') + '">';
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      });
    });
  }

  /* --- Variantes de la página de producto -------------------------------- */
  function initPdpVariants() {
    var root = document.querySelector('[data-mh-pdp]');
    if (!root) return;
    var dataEl = root.querySelector('[data-mh-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var optionInputs = root.querySelectorAll('[data-mh-opt]');
    if (!optionInputs.length) return;

    var idInput = root.querySelector('[data-mh-variant-id]');
    var priceEl = root.querySelector('[data-mh-price]');
    var wasEl = root.querySelector('[data-mh-was]');
    var saveEl = root.querySelector('[data-mh-save]');
    var addBtn = root.querySelector('[data-mh-add]');
    var addLabel = addBtn ? addBtn.querySelector('[data-mh-add-label]') : null;
    var money = root.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/i, value);
    }

    function currentSelection() {
      var sel = [];
      var groups = {};
      optionInputs.forEach(function (input) {
        var pos = input.getAttribute('data-mh-opt');
        if (input.type === 'radio') {
          if (input.checked) groups[pos] = input.value;
        } else {
          groups[pos] = input.value;
        }
      });
      Object.keys(groups).sort().forEach(function (k) { sel.push(groups[k]); });
      return sel;
    }

    function syncActive() {
      root.querySelectorAll('.mh-pdp__opt-values label').forEach(function (lab) {
        var input = lab.querySelector('input');
        if (input) lab.classList.toggle('is-active', input.checked);
      });
    }

    function update() {
      syncActive();
      var sel = currentSelection();
      var match = variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = 'No disponible';
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (wasEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          wasEl.textContent = formatMoney(match.compare_at_price);
          wasEl.hidden = false;
          if (saveEl) {
            var pct = Math.round((1 - match.price / match.compare_at_price) * 100);
            saveEl.textContent = '-' + pct + '%';
            saveEl.hidden = false;
          }
        } else {
          wasEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }
      if (addBtn) addBtn.disabled = !match.available;
      if (addLabel) addLabel.textContent = match.available
        ? (addBtn.getAttribute('data-label-default') || 'Agregar al carrito')
        : 'Agotado';

      // Cambia la foto principal si la variante tiene imagen propia
      if (match.image) {
        var stage = document.querySelector('[data-mh-stage]');
        if (stage) {
          stage.innerHTML = '<img src="' + match.image + '" alt="">';
          document.querySelectorAll('[data-mh-thumb]').forEach(function (t) {
            var on = t.getAttribute('data-full') === match.image;
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  }

  /* --- Selector de cantidad -------------------------------------------- */
  function initPdpQty() {
    document.querySelectorAll('[data-mh-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-mh-qty-input]');
      if (!input) return;
      function set(n) { input.value = Math.max(1, n | 0); input.dispatchEvent(new Event('change', { bubbles: true })); }
      wrap.querySelector('[data-mh-qty-minus]').addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
      wrap.querySelector('[data-mh-qty-plus]').addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
      input.addEventListener('input', function () { if (input.value !== '' && (parseInt(input.value, 10) || 0) < 1) input.value = 1; });
    });
  }

  /* --- Precio según cantidad (oferta "2da unidad al 50%", etc.) --------
     Se activa SOLO si el producto tiene los metacampos custom.qty_descuento_min
     y custom.qty_descuento_monto (Metadatos del producto). El descuento real
     de la venta lo aplica un descuento automático de Shopify con la MISMA
     cantidad mínima y el MISMO monto -> este precio es un preview fiel, no un
     número inventado: lo que se ve aquí es lo que se cobra en el checkout. */
  function initPdpQtyPricing() {
    var qtyWrap = document.querySelector('[data-mh-qty]');
    if (!qtyWrap) return;
    var min = parseInt(qtyWrap.getAttribute('data-qty-discount-min') || '0', 10);
    var amount = parseInt(qtyWrap.getAttribute('data-qty-discount-amount') || '0', 10);
    if (!min || !amount) return;

    var root = document.querySelector('[data-mh-pdp]');
    if (!root) return;
    var priceEl = root.querySelector('[data-mh-price]');
    var wasEl = root.querySelector('[data-mh-was]');
    var saveEl = root.querySelector('[data-mh-save]');
    var noteEl = root.querySelector('[data-mh-qty-note]');
    var input = qtyWrap.querySelector('[data-mh-qty-input]');
    if (!priceEl || !input) return;
    var money = root.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/i, value);
    }

    var basePrice = parseInt(priceEl.getAttribute('data-base-price') || '0', 10);
    var baseCompare = parseInt(priceEl.getAttribute('data-base-compare') || '0', 10);
    if (!basePrice) return;

    function render() {
      var qty = parseInt(input.value, 10) || 1;
      if (qty >= min) {
        var undiscounted = basePrice * qty;
        var total = undiscounted - amount;
        priceEl.textContent = formatMoney(total);
        if (wasEl) { wasEl.textContent = formatMoney(undiscounted); wasEl.hidden = false; }
        if (saveEl) { saveEl.textContent = '-' + Math.round((1 - total / undiscounted) * 100) + '%'; saveEl.hidden = false; }
        if (noteEl) { noteEl.textContent = 'por ' + qty + ' unidades'; noteEl.hidden = false; }
      } else {
        priceEl.textContent = formatMoney(basePrice);
        if (baseCompare > basePrice) {
          if (wasEl) { wasEl.textContent = formatMoney(baseCompare); wasEl.hidden = false; }
          if (saveEl) { saveEl.textContent = '-' + Math.round((1 - basePrice / baseCompare) * 100) + '%'; saveEl.hidden = false; }
        } else {
          if (wasEl) wasEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
        if (noteEl) noteEl.hidden = true;
      }
    }
    input.addEventListener('change', render);
    input.addEventListener('input', render);
    render();
  }

  /* --- Carrusel de productos destacados ---------------------------------- */
  function initDestCarousel() {
    document.querySelectorAll('[data-mh-dest]').forEach(function (root) {
      var track = root.querySelector('[data-mh-dest-track]');
      var prev = root.querySelector('[data-mh-dest-prev]');
      var next = root.querySelector('[data-mh-dest-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.querySelector('.mh-prod-card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = max <= 2 || track.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* --- Barra fija de compra en móvil ---------------------------------- */
  function easySellDrawerActive() {
    // EasySell deja el nodo .es-popup-button-drawer en el DOM aunque esa función
    // esté APAGADA en su configuración (queda con visibility:hidden). Si solo
    // miráramos si el nodo existe, escondíamos la barra propia sin que EasySell
    // pusiera ninguna a cambio -> ficha sin botón fijo. Por eso se revisa que
    // esté realmente visible.
    var el = document.querySelector('.es-popup-button-drawer');
    if (!el) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }
  function stickyHasEasySellButton(bar) {
    var el = bar.querySelector('.es-popup-button, .es-popup-button-product');
    if (!el) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }
  function initPdpSticky() {
    var bar = document.querySelector('[data-mh-sticky]');
    var anchor = document.querySelector('.mh-pdp__buy');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    // pequeño margen para dejar que EasySell termine de montar su widget
    setTimeout(function () {
      if (easySellDrawerActive()) return; // EasySell ya pone su propia barra fija
      // La barra solo debe traer el botón verde de EasySell (contraentrega).
      // Si por lo que sea EasySell no lo inyectó ahí, mostramos nuestro botón
      // de respaldo para que la barra nunca quede vacía.
      if (!stickyHasEasySellButton(bar)) {
        var fallback = bar.querySelector('[data-mh-sticky-fallback]');
        if (fallback) fallback.hidden = false;
      }
      var io = new IntersectionObserver(function (entries) {
        // muestra la barra cuando el botón principal NO está a la vista
        bar.classList.toggle('is-on', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(anchor);
    }, 900);
  }

  function boot() {
    initReveal();
    initPdpGallery();
    initPdpVariants();
    initPdpQty();
    initPdpQtyPricing();
    initPdpSticky();
    initDestCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
